import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Alert from '../components/common/alert'

import { clearAlert } from '../actions/alerts'

class Alerts extends Component {
  render() {
    const { alerts } = this.props

    if (alerts.length === 0) return null

    return (
      <div className="alerts">
        {
          alerts.map((alert, index) => {
            return alert.status !== 'resolved'
            ? <Alert key={index}
                alert={alert}
                clearAlert={() => this.props.clearAlert(index)} />
            : null
          })
        }
      </div>
    )
  }
}

Alerts.propTypes = {
  alerts: PropTypes.array
}

Alerts.defaultProps = {
  alerts: []
}

export const mapStateToProps = (state) => {
  return {
    alerts: state.alerts
  }
}

export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    clearAlert
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Alerts)



// WEBPACK FOOTER //
// ./src/containers/alerts.js